import { IOrganization } from '#backend/common/organization-types';
import { Component, inject, input, resource } from '@angular/core';
import { Router } from '@angular/router';
import { SmartOrpcClientService } from '../../../shared/services/smart-orpc-client.service';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { OrganizationFormComponent } from '../organization-form/organization-form.component';

@Component({
  selector: 'app-edit-organization',
  imports: [OrganizationFormComponent],
  templateUrl: './edit-organization.component.html',
  styleUrl: './edit-organization.component.scss',
})
export class EditOrganizationComponent {
  orpc = inject(SmartOrpcClientService);
  router = inject(Router);
  snackBar = inject(SnackbarService);
  readonly id = input.required<string>();
  readonly organization = resource({
    params: () => ({ id: this.id() }),
    loader: async ({ params }) => {
      const { error, data } = await this.orpc.safeClient.organization.byId(
        Number(params.id),
      );
      if (error) {
        return;
      }
      return data;
    },
  });

  async onSubmit({ name, cnpj }: Pick<IOrganization, 'name' | 'cnpj'>) {
    const {
      error,
      data: meta,
      isDefined,
    } = await this.orpc.safeClient.organization.update(
      {
        id: Number(this.id()),
        organization: { name, cnpj },
      },
      // Trata as mensagens de erro manualmente abaixo (CONFLICT tem mensagem própria)
      { context: { suppressErrorAlert: true } },
    );

    if (error && !isDefined) {
      this.snackBar.handleOrpcError(error);
    } else if (error && isDefined) {
      if (error.code === 'CONFLICT') {
        this.snackBar.alert(error.message);
      }
    } else {
      this.snackBar.alert('Cadastro de cliente alterado com sucesso!');

      this.router.navigate(['admin', 'organizations']);
    }
  }
}
